import axios from "../../../axios";
import React, { useEffect, useRef, useState } from "react";
import NestedReply from "./NestedReply";
import "./reply.css";
import ThreedotPopup from "./ThreedotPopup";
import EditReply from "./ThreeDot_Edit _Delete/EditReply";
import moment from "moment";
import { iconData } from "../../../iconData";
import { IP } from "../../../internalServer";
import { Popup } from "semantic-ui-react";
import DeleteReply from "./ThreeDot_Edit _Delete/DeleteReply";
import { useSelector } from "react-redux";
import LikePopUp from "./LikePopUp";
import CrossQueryAttachmentSoft from "./CrossQueryAttachmentSoft";
import { Tooltip } from "@mui/material";
import PdfViewer from "../../../HwManagement/PdfViewer/PdfViewer";
import { shortenParagraph } from "../../../utils/Engagement";


const Reply = ({
  queryStatus,
  reply,
  setReply,
  setNestedInput,
  setParentReply,
  setDeleted,
  setEdited,
  queryId,
  setFilter,
  getReplyReload
}) => {
  const currentUser = useSelector((state) => state.user.currentUser);
  const [delet, setDelet] = useState(false);
  const [clickThreeDot, setClickThreeDot] = useState(false);
  const [clickEditReply, setClickEditReply] = useState(false);
  const [likeClick, setLikeClick] = useState(false);
  const [likeCount, setLikeCount] = useState(reply?.likes?.length);
  const [isOpen, setIsOpen] = useState(false);
  const [attachments, setAttachments] = useState(reply.attachments);
  const [replyAttach, setReplyAttach] = useState([]);
  const [attachmentsCpy, setAttachmentsCpy] = useState(reply.attachments);
  const [responseAttach, setResponseAttach] = useState();
  const [isError, setIsError] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [pedingSubDetail, setPedingSubDetail] = useState({
    pdfView: false,
  });
  const handleRemovePdfVivwer = () => {
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: false,
    });
  };
  // let attachments = reply.attachments;
  const user_id = currentUser?.id;
  let user;
  if (user_id === reply?.user_id?.id) {
    user = true;
  }
  useEffect(() => {
    setLikeClick(reply.likes.includes(user_id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reply.id]);

  const [replycpy, setreplyCnt] = useState(reply);
  const [likedRes, setLikedRes] = useState(null);

  const handleLike = async () => {
    try {
      setLikeCount(likeClick ? likeCount - 1 : likeCount + 1);
      setLikeClick(!likeClick);
      let res = await axios.put(`/query/reply/like/${reply.id}`, {
        user_id: user_id,
      });
      setLikedRes(res.data.data);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    if (likedRes) {
      setreplyCnt((prevReply) => ({ ...prevReply, ...likedRes }));
    }
  }, [likedRes, setReply]);
  const handleClick = () => {
    setNestedInput(true);
    setParentReply(reply);
  };

  const executeScroll = () => {
    var targetSection = document.getElementById(reply?.parent_reply_id?.id);
    targetSection.scrollIntoView({ behavior: "smooth" });
    targetSection.classList.add("highlighted");

    setTimeout(function () {
      targetSection.classList.remove("highlighted");
    }, 1000);
  };

  const handaleThreeDot = () => {
    if (clickThreeDot) {
      setClickThreeDot(false);
    } else {
      setClickThreeDot(true);
    }
  };

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const userOffset = dateObj.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
    const localDate = new Date(dateObj - userOffset); // Convert to local time

    const day = localDate.getDate();
    const month = localDate.getMonth() + 1;
    const year = localDate.getFullYear();
    const hours = localDate.getHours();
    const minutes = localDate.getMinutes();
    const seconds = localDate.getSeconds();

    const outputDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return outputDateString;
  };

  const handleSoftDelete = (index) => {
    if (index < 0 || index >= attachments.length) {
      return attachments;
    }
    setAttachments([
      ...attachments.slice(0, index),
      ...attachments.slice(index + 1),
    ]);
    setReplyAttach([])
  };

  const handleAttachment = async (files) => {
    let attachments1 = []; // Use a copy of the original attachments
    let totalSize = replyAttach.reduce((acc, file) => acc + file.size, 0);
    if (files) {
      if (replyAttach.length + files.length > 5) {
        window.alert("You can upload a maximum of 5 files.");
        return;
      } else {
        for (const file of files) {
          const allowedTypes = [
            "application/pdf",
            "image/jpeg",
            "image/jpg",
            "image/png",
            "audio/mpeg",
            "video/mp4",
          ];
          const maxSizeInMB = file.type.startsWith("image")
            ? 5
            : file.type === "audio/mpeg"
              ? 50
              : 250;
          const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

          if (!allowedTypes.includes(file.type)) {
            window.alert(
              `Only PDF, JPEG, PNG, MP3, and MP4 files are allowed.`
            );
            continue;
          }

          if (file.size > maxSizeInBytes) {
            window.alert(
              `File size exceeds ${maxSizeInMB} MB for ${file.name}.`
            );
            continue;
          }

          totalSize += file.size;

          if (totalSize > 10 * 1024 * 1024) {
            window.alert("Total attachment size should not exceed 10 MB.");
            return;
          }

          let formData = new FormData();
          formData.append("name", file.name);
          formData.append("uploadReplyAttachment", file);
          setReplyAttach((prev) => [...prev, file]);
          try {
            let res = await axios.post(
              `/reply/uploadAttachment/userId/${currentUser?.id}`,
              formData
            );
            res && attachments1.push(res.data.data);
            console.log(attachments1);
          } catch (error) {
            console.log(error);
          }
        }
      }
      if (attachments1.length > 0) {
        setAttachments((prev) => [...prev, ...attachments1]);
      }
      setReplyAttach([]);
    }
  };

  const handleClickAttachment = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };

  const handleClickforpdf = (attachment) => {
    setResponseAttach(attachment)
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: true,
    });
  };

  return (
    <>
      {!(reply?.isDeleted && !user) && (
        <div className="reply_container w-full my-2">
          <div className="w-full flex gap-2 highlight_section " id={reply?.id}>
            <div>
              {
                reply?.user_id?.role === "Teacher" ?
                  <img
                    src={
                      reply?.user_id?.profile_picture
                        ? IP + reply?.user_id?.profile_picture.replace(/^\./, "")
                        : reply?.user_id?.gender === "M"
                          ? "/images/Teacher_Male.jpg"
                          : reply?.user_id?.gender === "F"
                            ? "/images/Teacher_Female.png"
                            : "/images/default image.png"
                    }
                    alt="icon"
                    className=""
                    style={{ width: "40px", height: "40px", borderRadius: "20%", cursor: "pointer" }}
                    key={reply?.user_id?.avatarProfile}
                    onError={(e) => {
                      if (reply?.user_id?.gender === "M") {
                        e.target.src = "/images/Teacher_Male.jpg"
                      } else if (reply?.user_id?.gender === "F") {
                        e.target.src = "/images/Teacher_Female.png"
                      } else {
                        e.target.src = "/images/default image.png"
                      }
                    }}
                  /> : <img
                    src={
                      reply?.user_id?.profile_picture
                        ? IP + reply?.user_id?.profile_picture.replace(/^\./, "")
                        : reply?.user_id.gender === "M"
                          ? reply?.user_id?.avatarProfile ? '/images/Boys/' + reply?.user_id?.avatarProfile + '.webp'
                            : "/images/Student_boy_pic.png"
                          : reply?.user_id?.gender === "F"
                            ? reply?.user_id?.avatarProfile ? '/images/Girls/' + reply?.user_id?.avatarProfile + '.webp'
                              : "/images/Student_girl_pic.png"
                            : "/images/default image.png"
                    }
                    alt="icon"
                    className=""
                    style={{ width: "40px", height: "40px", borderRadius: "20%", cursor: "pointer" }}
                    key={reply?.user_id?.avatarProfile}
                    onError={(e) => {
                      if (reply?.user_id?.gender === "M") {
                        e.target.src = reply?.user_id?.avatarProfile ? '/images/Boys/' + reply?.user_id?.avatarProfile + '.webp' : "/images/Student_boy_pic.png"
                      } else if (reply?.user_id?.gender === "F") {
                        e.target.src = reply?.user_id?.avatarProfile ? '/images/Girls/' + reply?.user_id?.avatarProfile + '.webp' : "/images/Student_girl_pic.png"
                      } else {
                        e.target.src = "/images/default image.png"
                      }
                    }}
                  />
              }
            </div>
            <div className="reply_container p-1 gap-1 w-[96%] border"
              style={{
                backgroundColor: "#f8f8f8",
                borderRadius: "10px",
                border: "1px solid #eee",
                alignItems: "flex-start",
                position: "relative",
              }}
            >
              <div className="">
                <div className="w-full flex justify-between">
                  <div>
                    {user ? (
                      <span className="badge bg-primary poppins-semibold">You</span>
                    ) : (
                      <span className="badge bg-primary poppins-semibold">{reply.user_id.name}</span>
                    )}
                  </div>
                  <div className="mr-2">
                    {user && (
                      <Popup
                        trigger={
                          <img
                            className="like_comment_icon"
                            src="/images/three dot hr.svg"
                            alt=""
                            style={{ cursor: reply?.isDeleted ? "not-allowed" : "pointer", opacity: reply?.isDeleted ? 0.5 : 1 }}
                            onClick={
                              !reply?.isDeleted && queryStatus === "approved" ? handaleThreeDot : null
                            }
                          />
                        }
                        content={
                          <div className="PopupBox">
                            {clickThreeDot && (
                              <ThreedotPopup
                                setClickThreeDot={setClickThreeDot}
                                setClickEditReply={setClickEditReply}
                                setDeleted={setDeleted}
                                clickThreeDot={clickThreeDot}
                                setReply={setReply}
                                delet={delet}
                                setDelet={setDelet}
                              />
                            )}
                          </div>
                        }
                        on="click"
                        hideOnScroll
                        position="bottom right"
                      />
                    )}
                  </div>
                </div>

                {!clickEditReply && (
                  <p
                    className="w-[98%] comments-text mt-2 mb-2 poppins-semibold"
                    style={{ whiteSpace: "pre-wrap" }}
                  >
                    {reply.reply}
                  </p>
                )}

                <div
                  className="badge bg-secondary "
                  style={{ fontSize: "12px", maxWidth: "fit-content" }}
                >
                  {moment(reply.updated_at).calendar({
                    sameDay: "[Today]",
                    lastDay: "[Yesterday]",
                    lastWeek: "DD MMM ",
                    sameElse: "DD MMM ",
                  })}
                  {"  "} | {"  "}
                  {moment(reply.updated_at).calendar({
                    sameDay: "hh:mm A",
                    lastDay: "hh:mm A",
                    lastWeek: "hh:mm A ",
                    sameElse: "hh:mm A",
                  })}
                </div>
                {user && reply?.isDeleted && (
                  <span style={{ color: "red" }} className=" ms-2 reply_time">
                    *Deleted
                  </span>
                )}
              </div>

              <div className="my-2">
                {!reply?.isDeleted && (
                  <div className="gap-sm-2 gap-3 d-flex align-items-center like_reply_threeDot_box w-full">
                    <img
                      src="/images/reply.svg"
                      className="like_comment_icon"
                      alt=""
                      onClick={handleClick}
                    />
                    <span
                      style={{ cursor: "pointer" }}
                      className="like_reply"
                      onClick={handleClick}
                    >
                      Reply
                    </span>
                    {!likeClick ? (
                      <img
                        src="/images/like.png"
                        className="like_comment_icon"
                        onClick={
                          queryStatus === "approved" ? handleLike : () => { }
                        }
                        alt="icon"
                      />
                    ) : (
                      <img
                        src="/images/blue_like.png"
                        className="like_comment_icon"
                        onClick={
                          queryStatus === "approved" ? handleLike : () => { }
                        }
                        alt="icon"
                      />
                    )}
                    <span
                      className="like_reply"
                      style={{ cursor: "pointer" }}
                      onClick={queryStatus === "approved" ? handleLike : () => { }}
                    >
                      Like
                    </span>
                    <Popup
                      on="click"
                      open={isOpen}
                      trigger={
                        <span
                          onClick={() => { setIsOpen(true) }}
                          className="count_like d-flex align-items-center justify-content-center"
                        >
                          {likeCount}
                        </span>
                      }
                      content={
                        <div className="PopupBox">
                          <LikePopUp
                            post={replycpy}
                            likedRes={likedRes || {}}
                            setIsOpen={setIsOpen}
                            isReply={true}
                          />
                        </div>
                      }
                      hideOnScroll
                      position="bottom right"
                    />
                  </div>
                )}
              </div>

              {reply.parent_reply_id && (
                <div onClick={executeScroll}>
                  <NestedReply parentReply={reply.parent_reply_id} />
                </div>
              )}

              {clickEditReply && (
                <EditReply
                  setEdited={setEdited}
                  reply={reply}
                  attachment={attachments}
                  setReply={setReply}
                  setAttachments={setAttachments}
                  setClickEditReply={setClickEditReply}
                  queryId={queryId}
                  setAttachments1={setAttachments}
                  attachmentCopy={attachmentsCpy}
                  getReplyReload={getReplyReload}
                />
              )}
              {/* col-sm-5 mb-2 col-md-3 col-9 gap-3 px-2 py-1 */}
              <div className="mb-2 d-flex flex-wrap ">
                {attachments.length > 0 && !clickEditReply
                  ? attachments.map((attachment, index) => (
                    <div
                      className="flex query_attach_box align-items-center py-1 px-1 mr-2 mb-2"
                      onClick={() => {
                        const fileType = attachment.split(".").pop();
                        if (
                          fileType === "jpg" ||
                          fileType === "jpeg" ||
                          fileType === "png" ||
                          fileType === "mp4" ||
                          fileType === "JPG" ||
                          fileType === "JPEG" ||
                          fileType === "PNG" ||
                          fileType === "MP4"
                        ) {
                          handleClickAttachment(attachment);
                        } else if (
                          fileType === "pdf" ||
                          fileType === "PDF" ||
                          fileType === "ppt" ||
                          fileType === "PPT" ||
                          fileType === "PPTX" ||
                          fileType === "pptx"
                        ) {
                          handleClickforpdf(attachment);
                        }
                      }}
                    >
                      <>
                        {attachment.split(".").pop() === "jpg" ||
                          attachment.split(".").pop() === "jpeg" ||
                          attachment?.split(".").pop() === "JPEG" ||
                          attachment?.split(".").pop() === "JPG" ||
                          attachment?.split(".").pop() === "PNG" ||
                          attachment?.split(".").pop() === "mp4" ||
                          attachment?.split(".").pop() === "MP4" ||
                          attachment.split(".").pop() === "png" ? (
                          <div
                            // key={index}
                            onClick={() => {
                              if (!isError) {
                                handleClickAttachment(attachment);
                              }
                            }}
                            className="d-flex gap-2 p-1"
                          >
                            <div className="d-flex align-items-center">
                              <img
                                style={{ maxHeight: "19px" }}
                                src={`${iconData?.find(
                                  (i) =>
                                    i.extension ===
                                    attachment.substring(
                                      attachment.lastIndexOf(".") + 1
                                    )
                                )?.icon
                                  }`}
                                alt=""
                              />
                            </div>
                          </div>
                        ) : (
                          <div
                            className="d-flex align-items-center pdf_logo"
                            onClick={() => handleClickforpdf(attachment)}
                          >
                            <img
                              className="attachLogoActivity w-4"
                              src={`${iconData?.find(
                                (i) =>
                                  i.extension ===
                                  attachment?.match(/\.([^.]+)$/)[1]
                              )?.icon
                                }`}
                              alt=""
                            />
                          </div>
                        )}
                      </>
                      &nbsp;&nbsp;
                      {attachment.indexOf("_") > 0
                        ? attachment.substring(attachment.indexOf("_") + 1)
                        : attachment}
                      &nbsp;
                      <span style={{ color: "#677489" }} className=" me-2">
                        {/* (45kb) */}
                      </span>
                    </div>
                  ))
                  : attachments.length > 0 &&
                  attachments.map((item, index) => (
                    <div className=" mb-3 maxAttach">
                      <CrossQueryAttachmentSoft
                        key1={index}
                        attachment={item}
                        setAttach={setAttachments}
                        delete1={handleSoftDelete}
                      />
                    </div>
                  ))}
              </div>
            </div>

            {clickEditReply && (
              <div className="d-flex justify-content-end attchSt">
                <input
                  id="attachFile"
                  type="file"
                  multiple
                  style={{ display: "none" }}
                  onChange={(e) => handleAttachment(e.target.files)}
                />
                <label
                  className="d-flex align-items-center"
                  htmlFor="attachFile"
                  style={{ position: "absolute", top: "80px", left: "90%" }}
                >
                  <img src="/images/Attach.svg" alt="" />
                  <span className="query_attach1">Attach File</span>
                </label>
              </div>
            )}
            {pedingSubDetail.pdfView && (
              <PdfViewer
                handleRemovePdfVivwer={handleRemovePdfVivwer}
                attachment={responseAttach}
              />
            )}
            {isClicked &&
              (responseAttach.split(".").pop() === "mp4" || responseAttach.split(".").pop() === "MP4" ? (
                <div className="fullSizeImg ">
                  <div className="SubfullSizeImg">
                    <video className="videoPlayer" controls>
                      <source src={IP + responseAttach.replace(/^\./, "")} type="video/mp4" />
                    </video>
                    <div>
                      <img
                        className="crossIconImgQue"
                        onClick={handleClickAttachment}
                        src="/DCM-img/crossIcon.svg"
                        alt="Up Arrow"
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="fullSizeImg ">
                  <div className="SubfullSizeImg">
                    {
                      !isError ? (
                        <>
                          <img
                            className="imgMain"
                            src={IP + responseAttach?.replace(/^\./, "")}
                            alt="Full-size"
                            onError={(e) => {
                              setIsError(true)
                            }}
                          />
                          <div>
                            <img
                              className="crossIconImgQue"
                              onClick={handleClickAttachment}
                              src="/images/cross.png"
                              alt="Up Arrow"
                            />
                          </div>
                        </>
                      ) : (
                        <div className="fullSizeImg" style={{ display: "flex", flexDirection: "column" }}>
                          <img
                            onClick={() => {
                              setIsError(false)
                              handleClickAttachment()
                            }}
                            src="/images/cross.png"
                            alt="Up Arrow"
                            style={{ position: "absolute", top: "75px", right: "40%" }}
                          />
                          <img src="/images/no-photo1.png" alt="img" style={{ width: "25%" }} />
                          <p style={{ color: "red", fontSize: "20px", fontWeight: "500", marginRight: "35px" }}>Error!! failed to load the requested file!</p>
                        </div>
                      )
                    }
                  </div>
                </div>
              ))}
          </div>
          {delet && (
            <DeleteReply
              setReply={setReply}
              setDeleted={setDeleted}
              replyId={reply.id}
              setDelet={setDelet}
              setFilter={setFilter}
              getReplyReload={getReplyReload}
            />
          )}
          {/* {clickThreeDot && (
          
        )} */}
        </div>
      )}
    </>
  );
};

export default Reply;
